export const locale = {
    lang: 'en',
    data: {  
    'NOTIF': {
        'DESCRIPTION': 'Description',
        'NAME': 'Label',
        'TITLE': 'Send a message',
        'USER': 'User',
        'AFFECTER_USER': 'Assign user',
        'GROUPE': 'Groupe',
        'AFFECTER_GROUPE': 'Assign groupe',
        'REQUIRED_USER':'You must choose at least one recipient',
        'REQUIRED': 'This field is required',
        }
    }
};